import React from 'react';
import { progressBarStep, progressBarSection } from './ProgressBar.styles';
import { IProgressBarStep } from './ProgressBar';

interface IStepProps {
  step: IProgressBarStep;
  index: number;
  completed: boolean;
  active: boolean;
  numberOfSteps: number;
}

export const Step: React.FunctionComponent<IStepProps> = ({
  step,
  index,
  completed,
  active,
  numberOfSteps,
}) => {
  const complete = completed || active;
  const { classes: sectionStyles } = progressBarSection({
    numberOfSteps,
    stepIndex: index,
    complete,
  })();
  const { classes: stepStyles } = progressBarStep({ completed, active })();

  return (
    <React.Fragment>
      {index !== 0 && (
        <div className={`progress-bar-section ${sectionStyles.progressBarSection}`} />
      )}
      <div className={stepStyles.stepContainer}>
        <div className={`progress-step ${stepStyles.step}`}>{step.index}</div>
        <span className={stepStyles.text}>{step.label}</span>
      </div>
    </React.Fragment>
  );
};
